import { DraftSection } from "./DraftSection";
import { LogoutButton } from "./LogoutButton";

interface EmptyViewProps {
  message: string;
  conversationId: string;
}

export function EmptyView({ message, conversationId }: EmptyViewProps) {
  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="flex flex-1 items-center justify-center text-center">
        <p className="text-sm text-(--text-muted,#6b7280)">{message}</p>
      </div>
      {conversationId && <DraftSection conversationId={conversationId} />}
      <LogoutButton />
    </div>
  );
}
